<template>
  <div class="DockingDetailsTopLeftMovieList">
    <div class="contentHidden">
      <div class="content">
        <div class="contentLi" v-for="(item,index) in videoList" :key="index">
          <img :src="item.coverurl" alt="" />
          <div class="contentLiTitle">{{item.title}}</div>
        </div>
      
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  props: {
    videoList:Array
  },
  components: {},
  data() {
    return {};
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
/* 隐藏overflow:auto的滚动条 */
.contentLi::-webkit-scrollbar {
  display: none;
}
@media (max-width: 768px) {
  /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
}
.DockingDetailsTopLeftMovieList {
  margin: 0 21px;
  margin-top: 20px;
}
.contentHidden{
    overflow: hidden;
}
.content {
  height: 430px;
  overflow: auto;
  /* overflow-y:hidden; */
  width: 110%;
}
.contentLi {
  display: flex;
  justify-content: left;
  margin-top: 10px;
  margin-right: 17px;
  cursor: pointer;
}
.contentLi img {
   width: 117px;
	height: 81px;
}
.contentLiTitle {
  text-align: left;
  
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  margin-left: 17px;
  padding-top: 31px;
}
</style>